import React, { useEffect, useState } from "react";
import Banner from "../Components/Homepage/Banner";
import BestSelling from "../Components/Homepage/BestSelling";
import Videos from "../Components/Homepage/Videos";
import BackgroundBanner from "../Components/Homepage/BackgroundBanner";
import Combooffer from "../Components/Homepage/Combooffer";
import Addsec from "../Components/Homepage/Addsec";
import Addtwosec from "../Components/Addtwosec";
import Customer from "../Components/Homepage/Customer";
import Testimonial from "../Components/Homepage/Testimonial";
import QuickLink from "../Components/Homepage/QuickLink";
import AOS from "aos";
import "aos/dist/aos.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchClassificationsList } from "../features/classificationSlice";
import { apiurl } from "../Constants";
const Homepage = () => {
  const [sectionOrder, setSectionOrder] = useState([]);

  const dispatch = useDispatch();
  const { classifications, status } = useSelector(
    (state) => state.classificationlist
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchClassificationsList());
    }
  }, [dispatch, status]);

  useEffect(() => {
    AOS.init({ once: false });
    const handleScroll = () => AOS.refresh();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    fetch(apiurl + "short_list")
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 200) {
          setSectionOrder(data.data);
        }
      });
  }, []);

  const renderComponent = (item, index) => {
    const shortId = parseInt(item.short_id);
    const classificationIndex = parseInt(item.classification_id);

    switch (shortId) {
      case 1:
        return <QuickLink key={index} />;
      case 2: {
        const classificationData = classifications.find(
          (c) => parseInt(c.classification_id) === classificationIndex
        );
        return classificationData ? (
          <BestSelling key={index} data={classificationData} />
        ) : null;
      }
      case 3:
        return <Addsec key={index} />;
      case 4:
        return <Videos key={index} />;
      case 5:
        return <BackgroundBanner key={index} />;
      case 6:
        return <Combooffer key={index} />;
      default:
        return null;
    }
  };

  return (
    <>
      <Banner />
      {sectionOrder.map((item, index) => renderComponent(item, index))}
      <Addtwosec />
      <Customer />
      <Testimonial />
    </>
  );
};

export default Homepage;
